import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import "./Navbar.css";

const Navbar = () => {
  const { getWishlistItemCount } = useWishlist();
  const { getCartItemCount } = useCart();

  const [menuOpen, setMenuOpen] = useState(false);

  const wishlistCount = getWishlistItemCount();
  const cartCount = getCartItemCount();

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="navbar">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>
            <img src="/assets/star-gold-logo.png" alt="STAR GOLD" />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="navbar-links">
          <Link to="/">Home</Link>

          <Link to="/collections">Collections</Link>

          <Link to="/contact">Contact</Link>

          <Link to="/track-order">Track Order</Link>
        </nav>

        {/* Right Side */}
        <div className="navbar-actions">
          <Link to="/wishlist" className="navbar-action">
            <span className="navbar-icon">♡</span>

            <span className="navbar-action-text">Wishlist</span>

            {wishlistCount > 0 && (
              <span className="navbar-count">{wishlistCount}</span>
            )}
          </Link>

          <Link to="/cart" className="navbar-action">
            <span className="navbar-icon">🛍</span>

            <span className="navbar-action-text">Cart</span>

            {cartCount > 0 && <span className="navbar-count">{cartCount}</span>}
          </Link>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-button"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Open navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`mobile-navigation ${
          menuOpen ? "mobile-navigation-open" : ""
        }`}
      >
        <Link to="/" onClick={closeMenu}>
          Home
        </Link>

        <Link to="/collections" onClick={closeMenu}>
          Collections
        </Link>

        <Link to="/contact" onClick={closeMenu}>
          Contact
        </Link>

        <Link to="/track-order" onClick={closeMenu}>
          Track Order
        </Link>

        <Link to="/wishlist" onClick={closeMenu}>
          Wishlist
          {wishlistCount > 0 && (
            <span className="mobile-count">{wishlistCount}</span>
          )}
        </Link>

        <Link to="/cart" onClick={closeMenu}>
          Cart
          {cartCount > 0 && <span className="mobile-count">{cartCount}</span>}
        </Link>
      </div>
    </header>
  );
};

export default Navbar;
